import { Dispatch, useEffect } from "react";
import { AppointmentsApi } from "../../Api/AppointmentsApi";
import { AppointmentDto } from "../../../../Api/Model/AppointmentDto.csharp";
import { FormFields, FormReducer } from "../Helpers/formTypes";
import { pricingSummaryInitialState } from "../Helpers/initialState/pricingSummaryInitialState";
import { isObjectEmpty } from "../Helpers";

const appointmentsApi = new AppointmentsApi();

export const usePricingSummary = (
  appointment: AppointmentDto,
  dispatch: Dispatch<any>
) => {
  useEffect(() => {
    if (!appointment.serviceVariantId) {
      dispatch({
        type: FormReducer.update,
        field: FormFields.pricingSummary,
        payload: pricingSummaryInitialState,
      });
    }
    (async () => {
      if (!isObjectEmpty(appointment) && appointment.serviceVariantId) {
        const summary = await appointmentsApi.getPricingSummary(
          appointment.serviceVariantId,
          appointment.serviceId,
          appointment.centerId,
          appointment.startTime
        );
        if (summary != null) {
          dispatch({
            type: FormReducer.update,
            field: FormFields.pricingSummary,
            payload: summary,
          });
        }
      }
    })();
  }, [appointment]);
};
